SupportFlexPhoneChannelTemplate = require '../../../../flex_phone_channel.html.mustache'
Backbone = require 'backbone'
Backbone.$ = $

class EmailFormIntlPhoneChannelView extends Backbone.View

  initialize: ->
    @I18nScope = 'modules.support'
    @template = SupportFlexPhoneChannelTemplate

  render: ->
    @$el.html(toHtml(@template, @toHash(), @I18nScope))

  toHash: ->
    if window.liveChatInfo?.mode?.step_three? then mode = window.liveChatInfo.mode.step_three
    hash =
      call_us_message : getCallUsMsg()
      showStaticLiveChat: isStaticLiveChat(mode) or isBothLiveChats mode

module.exports = EmailFormIntlPhoneChannelView
